import warnIcon from '@icons/streamline-icons/Outline version/01-Interface Essential/14-Alerts/alert-triangle.svg';
import errorIcon from '@icons/streamline-icons/Outline version/01-Interface Essential/33-Form-Validation/remove-square.svg';
import successIcon from '@icons/streamline-icons/Outline version/01-Interface Essential/33-Form-Validation/check-circle-1.svg';

export default {
  props: {
    validatorResult: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    validatorIcon() {
      if (this.normalizedValidatorResult.hasError) {
        return errorIcon;
      }

      if (this.normalizedValidatorResult.hasWarning) {
        return warnIcon;
      }

      return successIcon;
    },
    normalizedValidatorResult() {
      return {
        isDirty: false,
        hasPassedValidator: true,
        message: '',
        hasError: false,
        hasWarning: false,
        ...this.validatorResult,
      };
    },
    problemClasses() {
      return {
        danger: this.normalizedValidatorResult.hasError,
        warn: this.normalizedValidatorResult.hasWarning,
      };
    },
  },
};
